import Step1 from "../../../../../public/services-step-1.png";
import Step2 from "../../../../../public/services-step-2.png";
import Step3 from "../../../../../public/services-step-3.png";

export const steps = [
  {
    src: Step1.src,
    title: "One go-to point of contact",
    description:
      "Cynthia's background in home operations and customer service allows her to triage issues, coordinate with vendors, provide consistent updates, and she can guarantee fantastic around-the-clock customer experience."
  },
  {
    src: Step2.src,
    title: "On-the-ground expertise",
    description:
      "John is your assigned local expert. He's been a local in your area, and has 20+ years of home trades experience (HVAC, electrical, carpentry, etc.) He's going to help diagnose, recommend, and provide guidance on what you need, whenever you need it. There's no project too big for John — he's seen it all."
  },
  {
    src: Step3.src,
    title: "All though our app",
    description:
      "You'll have access to the Humming Homes app, where you can communicate, pay invoices, submit project requests — all with the touch of a button."
  }
];
